/// <amd-module name="Search/Shared/Base/ActionsHub2" />
import { Action } from "VSS/Reflux/Action";
import { IOrganizationInfo } from "Search/Shared/Base/Stores/OrganizationInfoStore";
import * as SearchShared from "Search/WebApi/Contracts/Search.Shared";

export interface ISearchStartedPayload<TRequest extends SearchShared.EntitySearchRequest> {
    request: TRequest;

    sortScenario?: boolean;

    filterApplication?: boolean;

    fetchMoreScenario?: boolean;

    searchTextModified?: boolean;
}

export interface IResultsLoadedPayload<TRequest extends SearchShared.EntitySearchRequest, TResponse extends SearchShared.EntitySearchResponse, TItem> {
    response: TResponse;

    request: TRequest;

    source: SearchSourceType;

    activeItem?: TItem;

    activityId?: string;

    fetchMoreScenario?: boolean;
}

export interface ISearchFailedPayload<TRequest extends SearchShared.EntitySearchRequest> {
    query: TRequest;

    error: any;

    activityId: string;
}

export interface IPageInitializationStartedPayload<TRequest extends SearchShared.EntitySearchRequest>
    extends ISearchStartedPayload<TRequest> {
    activeTabKey?: string;

    isLandingPage?: boolean;

    launchPoint?: string;
}

export enum SearchSourceType {
    DataProvider,

    RestApi
}

export class ActionsHub<
    TRequest extends SearchShared.EntitySearchRequest,
    TResponse extends SearchShared.EntitySearchResponse,
    TItem
    > {
    public searchStarted = new Action<ISearchStartedPayload<TRequest>>();
    public resultsLoaded = new Action<IResultsLoadedPayload<TRequest, TResponse, TItem>>();
    public searchFailed = new Action<ISearchFailedPayload<TRequest>>();
    public pageInitializationStarted = new Action<IPageInitializationStartedPayload<TRequest>>();
    public filterPaneToggled = new Action<void>();
    public organizationInfoLoaded = new Action<IOrganizationInfo>();
    public organizationInfoLoadFailed = new Action<{}>();
    public errorNotificationBannerDismissed = new Action<{}>();
    public filterReset = new Action<{}>();
}
